<template>
  <div class="msgDetails">
    <div class="zMsgSearch">
      <span>{{$t('common.dateRange')}}</span>
      <el-date-picker
        size="small"
        v-model="DataValue"
        type="datetimerange"
        :clearable="false"
        value-format="yyyy-MM-dd HH:mm:ss"
:range-separator="$t('common.to')"
     :start-placeholder="$t('common.starDate')"
     :end-placeholder="$t('common.endDate')"
      >
      </el-date-picker>
      <el-button
        style="margin-left: 18px"
        @click="onSearch"
        size="small"
        type="primary"
        class="btn-chaxun"
        >{{$t('common.btn.search')}}</el-button
      >
      <el-button @click="onClear" size="small" class="btn-del">{{$t('common.btn.cancel')}}</el-button>
    </div>
    <div class="zMsgTable">
      <i-table
      :list="list"
      :height="height"
      ref="carTable"
      @handleSelectionChange="handleSelectionChange"
      :options="option"
      :columns="columns"
      :operates="operates"
    ></i-table>
    <IPagination ref="page" @PageFun="changeSize"></IPagination>
    </div>
    
  </div>
</template>

<script>
import iTable from "../../../../../src/components/Table.vue";
import IPagination from "../../../../../src/components/pagination.vue";
export default {
    props: ["bindDriver"],
    
  components: {
    iTable,
    IPagination,
  },
  data() {
    return {
      DataValue: [],
      height: "350",
      list: [], 
      option: {
        stripe: true, 
        border: true,
        loading: false, 
        highlightCurrentRow: false, 
        mutiSelect: false, 
        serialNumber: true, 
      },
      columns: [
        {
          prop: "workTime",
          label: this.$t('DriverAnalysis.workHour'),
          align: "center",
          width: '160'
        },
        {
          prop: "openTime",
          label: this.$t('DriverAnalysis.startTime'),
          align: "center",
          // render: (h, params) => {
          //   return h('span', this.$formatTime(params.row.openTime))
          // }
        },
        {
          prop: "closeTime",
          label: this.$t('DriverAnalysis.endTime'),
          align: "center",
          // render: (h, params) => {
          //   return h('span', this.$formatTime(params.row.closeTime))
          // }
        },
      ],
      operates: {
        width: 100,
        fixed: "right",
        list: [],
      },
      currentPage: 1, 
      pageSize: 10, 
      total: 1, 
      bindValue:''
    };
  },
  created() {
     
  },
  methods: {
     getDriverSwipingCard() {
        let startTime = ''
        let endTime = ''
        if (this.DataValue && this.DataValue.length > 0) {
            startTime = this.DataValue[0]
            endTime = this.DataValue[1]
        }
        let param = {
            driverNum: this.bindDriver,
            startTime: startTime,
            endTime: endTime,
            pageNum: this.currentPage,
            pageSize: this.pageSize,
        }
        this.$store.dispatch('VehicleStatus/GET_DRIVERSWIPINGCARD', param).then(res => {
            if (res) {
                console.log(res)
                if (res.data.code == 200) {
                    this.list = res.data.data.list
                    this.$refs.page.CommandTotal = res.data.data.total
                }
            }
        }).catch(err => { })
    },
    onSearch() {
      this.getDriverSwipingCard()
    },
    onClear() {
      this.DataValue = []
      this.getDriverSwipingCard()
    },
    handleSelectionChange(val) {
      this.selected = val;
    },
    changeSize(item) {
      this.pageSize = item.pageSize;
      this.currentPage = item.pageNum;
      this.getDriverSwipingCard();
    },
  },
};
</script>

<style lang="less" scoped>
@import url('./index.less');
</style>